module.exports = __webpack_public_path__ + "static/media/girl-21.e528d984.svg";